/**
 * Unified multi-script font stack for the whole platform.
 *
 * The browser resolves the font per-character, so Latin text renders with Inter
 * while each non-Latin script falls back to the matching Noto Sans face. All of
 * these are loaded as web fonts in `index.html`, so typography looks identical
 * and professional across every OS and language (incl. Arabic, Urdu, Hindi,
 * Bengali, Sinhala, Nepali) instead of relying on inconsistent system fonts.
 */
export const APP_FONT_FAMILY = [
  '"Inter"',
  '"Noto Sans Arabic"',
  '"Noto Sans Devanagari"',
  '"Noto Sans Bengali"',
  '"Noto Sans Sinhala"',
  '"Helvetica"',
  '"Arial"',
  'sans-serif',
].join(', ');
